import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuetify from 'vuetify'

import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import HttpService from './Http.js'
import VueI18n from 'vue-i18n'
import messages from './assets/messages.json'
import VueNoty from 'vuejs-noty'
import 'vuetify/dist/vuetify.min.css'
import 'vue-cal/dist/vuecal.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Vue Components
import FirstDashboard from './components/FirstDashboard.vue'
import Home from './components/Home.vue'
import AboutPage from './components/AboutPage.vue'


// Main Page
import App from './views/App.vue'

Vue.config.productionTip = false

Vue.prototype.$axios = HttpService

window.Vue = Vue;

// Use base Components
Vue.use(BootstrapVue)
Vue.use(Vuetify)
Vue.use(VueRouter)

// Components
Vue.use(FirstDashboard)
Vue.use(Home)
Vue.use(AboutPage)

// Language
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'de',
    messages,
});


// Vuetify
const vuetifyOpts = {
    theme: {
        themes: {
            light: {
                primary: "#0082DC",
                secondary: "#003A61",
                accent: "#82B1FF",
                error: "#FF5252",
                info: "#2196F3",
                success: "#4CAF50",
                warning: "#FB8C00",
                grey: "#2f2f2f",
            }
        }
    }
};
const vuetify = new Vuetify(vuetifyOpts);


// Vue Router
const router = new VueRouter({
    routes: [
        {
            path: "/", component: {
                template: "<router-view/>"
            }
        },
        { path: "/dashboard", component: FirstDashboard },
        { path: "/home", component: Home },
        { path: "/about", component: AboutPage },
    ],
    mode: "history"
});

Object.defineProperty(Vue.prototype, '$locale', {
    get: function () {
        return i18n.locale
    },
    set: function (locale) {
        i18n.locale = locale
    }
});


// Notifications
Vue.use(VueNoty, {
    timeout: 6000,
    progressBar: true,
    killer: true,
    layout: 'topRight'
});

function getQueryParam(searchWord, query) {
    const searchWordPosition = query.indexOf(searchWord);

    if (searchWordPosition >= 0) {
        const start = searchWordPosition + searchWord.length;

        const separatorPosition = query.indexOf("&", start);
        const end = separatorPosition === -1 ? query.length : separatorPosition;

        return query.substr(start, end - start);
    }
    return "";
}

const initialPageSwitch = function () {
    const query = window.location.search;
    if (query.length > 0) {
        const searchWord = "page="
        const page = getQueryParam(searchWord, query);

        switch (page) {
            case "dashboard":
                router.push("dashboard");
                break;
            case "":
                break;
        }
    }
}



new Vue({
    render: h => h(App),
    components: { App },
    i18n,
    router,
    vuetify,
    mounted: function () {
        initialPageSwitch();
        this.$locale = getQueryParam("lang=", window.location.search) === "en" ? "en" : "de";
    },
    methods: {
        setUser(user) {
            this.user = user;
        },
    }
}).$mount("#app");